<template>
  <v-dialog v-model="evaluationDetalhesModal" scrollable persistent full-width max-width='933'>
    <v-card>
      <v-card-title>
        <v-flex>
          <span class="titulo-detalhes pl-4  mt-2 mb-2 headline">Responder</span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right">
          <v-btn icon @click.native="evaluationDetalhesModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
        <v-card-text class="pa-0">
          <v-form name="form-cadastro" ref="itemForm">
            <v-layout row wrap class="pl-5 pr-5 mt-3">
                <p>
                    <b>Data:</b> {{ evaluation.data | formatDate }}<br />
                    <b>Cliente:</b> {{ evaluation.usuario }}<br />
                    <b>Item:</b> {{ evaluation.item }}<br />
                    <b>Nota:</b> {{ evaluation.nota }}<br />
                    <b>Comentário:</b> <br />
                    {{ evaluation.comentario }}
                </p>
            </v-layout>
            <v-layout row wrap class="pl-5 pr-5">
              <v-flex xs12 sm12 md12>
                <v-text-field
                name="resposta"
                label="Resposta"
                :value="typeof evaluation.resposta !== 'undefined' ? evaluation.resposta : ''"
                @input="updateResposta"
                required
                multi-line
                @keydown="limitChar($event, 1000)"
                :counter="1000"
                >
                </v-text-field>                
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 mt-3 class="text-xs-center">
                <v-spacer></v-spacer>
                <v-btn flat outline round color="green" class="mb-4" :disabled="loadingEvaluationAction" @click.native="salvarResposta()"><v-icon left>done_all</v-icon>Gravar</v-btn>              
              </v-flex>
            </v-layout>
        
          <v-progress-linear class="loading-modal" v-if="loadingEvaluationAction" color="error" v-bind:indeterminate="true"></v-progress-linear>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'resposta-avaliacao',
  data () {
    return {
      ativo: false
    }
  },
  created () {
  },
  methods: {
    salvarResposta () {
      if (this.$refs.itemForm.validate()) {
        this.$store.dispatch('salvarResposta')
      } else {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'Verifique os campos em vermelho'
        })
      }
    },
    updateResposta (value) {
      this.$store.commit('updateResposta', value)
    },
    close () {
      this.$store.commit('closeItem')
    },
    limitChar (elem, limit) {
      if (elem.target.value.length === limit && elem.key !== 'Backspace') {
        elem.preventDefault()
      }
    }
  },
  computed: {
    loadingEvaluationAction () {
      return this.$store.getters.loadingEvaluationAction
    },
    evaluation () {
      return this.$store.getters.selectedAvaliacao
    },
    evaluationDetalhesModal: {
      get () {
        return this.$store.getters.evaluationVisible
      },
      set () {
        this.dataTags = ''
        this.$store.commit('toggleEvaluationModal', false)
      }
    }
  }
}
</script>
<style>
.prefix.input-group--prefix:not(.input-group--focused):not(.input-group--dirty) label{
  left: 23px!important;
}
.item-box{
  border: 1px solid #bdbdbd;
  border-radius: 15px;
  float: left;
}
.outerDiv{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
/* ajustes */
.titulo-detalhes{
    color: #e62039;
    font-size: 21px;
}
.titulo-detalhes .headline{
  font-size: 25px;
}
.titulo-detalhes-categoria{
  font-size: 21px;
  padding-top: 17px;
  color: #707983
}
p{
color: #838789
}
</style>



// WEBPACK FOOTER //
// avaliacaoResposta.vue?04495650